// BUG-015: CompanyProfileBanner and CompanyProfileSection each call
// useCompanyProfile() independently — separate hook instances, separate state, no
// shared cache. Saving on the Settings page updates only that instance, leaving
// the always-visible banner's stale "incomplete" state showing until it happens
// to remount (a route change). This is a minimal side-channel so a successful
// save can tell any other mounted instance to recheck, without restructuring
// useCompanyProfile's existing per-consumer API.
type Listener = () => void

const listeners = new Set<Listener>()

export function subscribeToProfileCompletionChanges(listener: Listener): () => void {
  listeners.add(listener)
  return () => listeners.delete(listener)
}

export function notifyProfileCompletionChanged(): void {
  for (const listener of listeners) listener()
}
